import React, { useState, useEffect } from "react";
import PrintLayout from "../../core/printLayout";
import dayjs from "dayjs";
import { getAge, getQuantity, to12HourFormat } from "../../utils/common";

const options = [
    { id: 1, label: "Vital Signs", isActive: true },
    { id: 2, label: "Clinical Notes", isActive: false },
    { id: 3, label: "Prescription", isActive: true },
    { id: 4, label: "Additional Notes", isActive: false },
    { id: 6, label: "MedicalHistory", isActive: false },
    { id: 5, label: "billing", isActive: false },
];

const PrintPres = ({ show, handleClose, appointment }) => {
    const [clinicalNotes, setClinicalNotes] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState(
        options
            .filter((option) => option.isActive)
            .map((option) => option.label),
    );
    const [showGenericNames, setShowGenericNames] = useState({});

    const handleCheckboxChange = (label) => {
        setSelectedOptions((prevSelected) =>
            prevSelected.includes(label)
                ? prevSelected.filter((option) => option !== label)
                : [...prevSelected, label],
        );
    };

    const handleGenericNameToggle = (index) => {
        setShowGenericNames((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    useEffect(() => {
        if (appointment && appointment.psychodiagnostic) {
            setClinicalNotes([...appointment.psychodiagnostic.chiefComplaints]);
        }
    }, [appointment]);

    const prescription = () => {
        return ` <div style="margin: 20px; background-color: #e0f7fa;">
       <div style="display: flex; justify-content: space-between;">
    <div style="border-radius: 8px; width: 45%;">
    <p style="color: grey; ">
      <span style="color: #0288d1;">Patient Name:</span> ${
          appointment?.patient?.firstName + " " + appointment?.patient?.lastName
      }
    </p>
    <p style="color: grey; ">
      <span style="color: #0288d1;">Mobile No :</span> ${
          appointment?.patient?.phoneNo || ""
      }
    </p>
    <p style="color: grey; ">
      <span style="color: #0288d1;">Address :</span> ${(
          appointment?.patient?.address || ""
      ).toUpperCase()}
    </p>
  </div>
  <div style="border-radius: 8px; width: 45%;">
    <p style="color: grey; ">
      <span style="color: #0288d1;">Age/Gender : </span>${
          (appointment.patient.birthDate &&
          appointment.patient.birthDate !== "Invalid date" &&
          getAge(appointment.patient.birthDate) > 0
              ? `${getAge(appointment.patient.birthDate)} years`
              : appointment.patient.age
                ? `${appointment.patient.age} years`
                : "0 years") +
          " / " +
          appointment.patient.gender
      }
    </p>
    <p style="color: grey; ">
      <span style="color: #0288d1;">Patient ID:</span> ${
          appointment?.patient?.patientNumber
      }
    </p>
    <p style="color: grey; ">
      <span style="color: #0288d1;">Date and Time:</span> ${
          dayjs(appointment?.date?.toLocaleString()).format("DD-MM-YYYY") +
          "/" +
          to12HourFormat(appointment.time)
      }
    </p>
  </div>
    </div>
      <p style="color: grey; ">
      <span style="color: #0288d1;">By:</span>Dr. ${appointment.doctor.name}
    </p>
    <hr/>
   ${
       selectedOptions.includes("Vital Signs") &&
       `
    <div style = "margin-top : 10px;">
    <h4>Vital Signs</h4>
    <table style="width: 100%; border-collapse: collapse; background-color: #f9f9f9; color: #616161; margin-bottom: 20px;max-width: 900px;">
      <thead>
        <tr>
          <th style="border: 1px solid #ddd; ">Weight (kg)</th>
          <th style="border: 1px solid #ddd; ">B.P. (mmHg)</th>
          <th style="border: 1px solid #ddd; ">Pulse (Heartbeats/min)</th>
          <th style="border: 1px solid #ddd; ">Temperature (°C)</th>
          <th style="border: 1px solid #ddd; ">Resp. Rate (breaths/min)</th>
        </tr>
      </thead>
      <tbody>
      ${
          appointment && appointment.vitalSigns
              ? `
        <tr style="background-color: #fafafa;">
          <td style="border: 1px solid #ddd;">${appointment.vitalSigns.weight}</td>
          <td style="border: 1px solid #ddd;">${appointment.vitalSigns.bp}</td>
          <td style="border: 1px solid #ddd;">${appointment.vitalSigns.pulse}</td>
          <td style="border: 1px solid #ddd;">${appointment.vitalSigns.temperature}</td>
          <td style="border: 1px solid #ddd;">${appointment.vitalSigns.respRate}</td>
        </tr>
        `
              : ""
      }
  
          
   
      </tbody>
    </table>
    </div>`
   }
  
${
    selectedOptions.includes("Clinical Notes")
        ? ` 
  <div style="margin-bottom: 10px;"> 
    <h4>Clinical Notes:</h4>  

    ${
        appointment?.clinicalNote
            ? `
${
    appointment.clinicalNote?.complaints
        ? `Complaints - ${appointment.clinicalNote.complaints}<br>`
        : ""
}
${
    appointment.clinicalNote?.presentIllness
        ? `Present Illness - ${appointment.clinicalNote.presentIllness}<br>`
        : ""
}
${
    appointment.clinicalNote?.investigations
        ? `Duration - ${appointment.clinicalNote.investigations}<br>`
        : ""
}
${
    appointment.clinicalNote?.psychiatricHistory
        ? `Past Psychiatric History - ${appointment.clinicalNote.psychiatricHistory}<br>`
        : ""
}
${
    appointment.clinicalNote?.medicalHistory
        ? `Medical History - ${appointment.clinicalNote.medicalHistory}<br>`
        : ""
}
${
    appointment.clinicalNote?.treatmentHistory
        ? `Treatment History - ${appointment.clinicalNote.treatmentHistory}<br>`
        : ""
}
${
    appointment.clinicalNote?.familyHistory
        ? `Family History - ${appointment.clinicalNote.familyHistory}<br>`
        : ""
}
${
    appointment.clinicalNote?.Observations
        ? `Observations - ${appointment.clinicalNote.Observations}<br>`
        : ""
}
${
    appointment.clinicalNote?.diagnosis
        ? `Prov. Diagnosis - ${appointment.clinicalNote.diagnosis}<br>`
        : ""
}
${
    appointment.clinicalNote?.notes
        ? `Notes - ${appointment.clinicalNote.notes}<br>`
        : ""
}
${
    appointment.clinicalNote?.investigations
        ? `Duration - ${appointment.clinicalNote.investigations}<br>`
        : ""
}


      `
            : ""
    }

  </div>`
        : ""
}

  
  
   ${
       selectedOptions.includes("Prescription")
           ? `
    <div>
    <h4>Prescriptions:</h4>
    <table style="width: 100%; border-collapse: collapse; color: #616161; margin-bottom: 20px; max-width : 900px;">
      <thead>
        <tr>
          <th style="border: 1px solid #ddd; ">S.No</th>
          <th style="border: 1px solid #ddd; ">Drug</th>
          <th style="border: 1px solid #ddd; ">Dosage</th>
          <th style="border: 1px solid #ddd; ">Duration</th>
          <th style="border: 1px solid #ddd; ">Instructions</th>
          <th style="border: 1px solid #ddd; ">Quantity</th>
        </tr>
      </thead>
      <tbody>
        ${
            appointment &&
            appointment.prescription &&
            appointment.prescription
                .map(
                    (pres, index) => `
          <tr key=${index} style="background-color: #fafafa;">
            <td style="border: 1px solid #ddd;">${index + 1}</td>
            <td style="border: 1px solid #ddd;">
              <div>${
                  (pres.drugType !== "custom"
                      ? pres.drugType?.toUpperCase()
                      : "" || ""
                  )?.toUpperCase() +
                  " " +
                  pres.drug
              }</div>
              ${
                  pres.genericName && showGenericNames[index]
                      ? `<div style="font-size: 11px; color: #757575; margin-top: 2px;">(${pres.genericName})</div>`
                      : ""
              }
            </td>
            <td style="border: 1px solid #ddd;">${pres.dosage}</td>
            <td style="border: 1px solid #ddd;">${
                pres.durationNumber + " " + pres.durationUnit
            }</td>
            <td style="border: 1px solid #ddd;">${pres.instruction}</td>
              <td style="border: 1px solid #ddd;">${
                  pres?.quantity ||
                  getQuantity(
                      pres.dosage,
                      pres.durationNumber + " " + pres.durationUnit,
                  )
              }</td>
          </tr>
        `,
                )
                .join("")
        }
      </tbody>
    </table>
    </div>
    `
           : " "
   }
  
    ${
        selectedOptions.includes("MedicalHistory")
            ? `
      <h4>Medical History</h4>
  ${
      appointment &&
      appointment.patient &&
      appointment.patient.medicalhistory?.length > 0
          ? `<div>
    ${appointment.patient.medicalhistory.join(", ")}
      </div>`
          : ""
  } `
            : ""
    }
     ${
         selectedOptions.includes("Additional Notes")
             ? `
     <div style="max-width: 900px; width: 100%; padding: 3px 0; font-size: 14px; font-family: Arial, sans-serif;">
  <h4 >Additional Notes:</h4>
  <p style="color: #616161; line-height: 1.6; word-break: break-word; white-space: pre-wrap; margin: 0;">
    ${appointment && appointment.notes !== undefined ? appointment.notes : ""}
  </p>
</div>
`
             : ""
     }
  </div>
  
   ${
       selectedOptions.includes("billing")
           ? `
       <div style = "page-break-before: always;margin-top:400px;padding : 24px; padding-top : 30px; max-width : 900px;">
               <div style="display: flex; justify-content: space-between;">
             <div style="border-radius: 8px; width: 45%;">
               <p style="color: grey; font-size: 14px;">
                 <span style="color: #0288d1;">Patient Name:</span> ${
                     appointment?.patient?.firstName +
                     " " +
                     appointment?.patient?.lastName
                 }
               </p>
               <p style="color: grey; font-size: 14px;">
                 <span style="color: #0288d1;">Mobile No :</span> ${
                     appointment?.patient?.phoneNo || ""
                 }
               </p>
               <p style="color: grey; font-size: 14px;">
                 <span style="color: #0288d1;">Address :</span> ${(
                     appointment?.patient?.address || ""
                 ).toUpperCase()}
               </p>
             </div>
             <div style="border-radius: 8px; width: 45%;">
               <p style="color: grey; font-size: 14px;">
                 <span style="color: #0288d1;">Age/Gender : </span>${
                     (appointment.patient.age
                         ? `${appointment.patient.age} years`
                         : appointment.patient.birthDate &&
                             appointment.patient.birthDate !== "Invalid date"
                           ? `${getAge(appointment.patient.birthDate)} years`
                           : "0 years") +
                     " / " +
                     appointment.patient.gender
                 }
               </p>
               <p style="color: grey; font-size: 14px;">
                 <span style="color: #0288d1;">Patient ID:</span> ${
                     appointment?.patient?.patientNumber
                 }
               </p>
               <p style="color: grey; font-size: 14px;">
                 <span style="color: #0288d1;">Date and Time:</span> ${
                     dayjs(appointment?.date?.toLocaleString()).format(
                         "DD-MM-YYYY",
                     ) +
                     "/" +
                     to12HourFormat(appointment.time)
                 }
               </p>
             </div>
               </div>
                 <p style="color: grey; font-size: 14px;">
                 <span style="color: #0288d1;">By:</span>Dr. ${
                     appointment.doctor.name
                 }
               </p>
               <hr/>
       
       <div style="margin-top: 8px; max-width : 700px;">
         <h5>Invoice</h5>
         <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
           <thead>
             <tr style="background-color: #f2f2f2; text-align: left;">
               <th style="border: 1px solid #ddd; padding: 8px;">#</th>
               <th style="border: 1px solid #ddd; padding: 8px;">Treatments & Products</th>
               <th style="border: 1px solid #ddd; padding: 8px;">Unit Cost (₹)</th>
               <th style="border: 1px solid #ddd; padding: 8px;">Discount</th>
               <th style="border: 1px solid #ddd; padding: 8px;">Total Cost (₹)</th>
             </tr>
           </thead>
           <tbody>
             ${appointment.billing?.treatment
                 ?.map(
                     (item, index) => `
               <tr>
                 <td style="border: 1px solid #ddd; padding: 8px;">${
                     index + 1
                 }</td>
                 <td style="border: 1px solid #ddd; padding: 8px;">${
                     item.name
                 }</td>
                 <td style="border: 1px solid #ddd; padding: 8px;">${
                     item.cost
                 }</td>
                 <td style="border: 1px solid #ddd; padding: 8px;">${
                     item.discount
                 }</td>
                 <td style="border: 1px solid #ddd; padding: 8px;">${(
                     item.unit * item.cost -
                     item.discount +
                     item.tax
                 ).toFixed(2)}</td>
               </tr>
             `,
                 )
                 .join("")}
           </tbody>
         </table>
       </div>
       
       <div style="margin-top: 8px; border-top: 1px solid #ddd; padding-top: 15px;max-width:700px;">
         <h5 style="font-weight: 700;">Summary</h5>
         <div style="display: flex; justify-content: space-between;">
           <div>
             <p>Total Cost: ₹${appointment.billing?.totalCost}</p>
             <p>Discount: ₹${appointment.billing?.totalDiscount}</p>
             <p>Tax: ₹${appointment.billing?.totalTax}</p>
           </div>
           <div>
             <p>Grand Total: ₹${appointment.billing?.grandTotal}</p>
           </div>
         </div>
       </div>
       
       <div style="margin-top: 8px; border-top: 1px solid #ddd; padding-top: 15px;">
         <h5 style="font-weight: 700;">Payment Details</h5>
         <p>Receipt Number: R#12345</p>
         <p>Mode of Payment: ${appointment.billing?.paymentMethod}</p>
         <p>Amount Paid: ₹${appointment.billing?.amountPaid}</p>
         <p>Due Amount: ₹${
             (
                 appointment.billing.totalCost -
                 appointment.billing.totalDiscount +
                 appointment.billing.totalTax
             ).toFixed(2) - appointment.billing.amountPaid
         }</p>
       </div>
       
       `
           : ""
   }
  `;
    };

    return (
        <>
            {show && (
                <div
                    className="modal show d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ overflow: "scroll", backdropFilter: "blur(20px)" }}
                >
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Prescription</h5>
                                <button type="button" onClick={handleClose}>
                                    <i class="fa fa-window-close"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <main
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-around",
                                        alignContent: "center",
                                        marginTop: "20px",
                                    }}
                                >
                                    <div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                width: "100%",
                                                top: 0,
                                                right: "10",
                                            }}
                                        >
                                            <PrintLayout
                                                html={prescription}
                                                category={"prescription"}
                                            ></PrintLayout>
                                        </div>
                                        {appointment && (
                                            <div
                                                style={{
                                                    marginTop: "70px",
                                                    borderRadius: "8px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            borderRadius: "8px",
                                                            width: "45%",
                                                        }}
                                                    >
                                                        <p
                                                            style={{
                                                                color: "grey",
                                                                fontSize:
                                                                    "14px",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#0288d1",
                                                                }}
                                                            >
                                                                Patient Name:
                                                            </span>{" "}
                                                            {appointment
                                                                ?.patient
                                                                ?.firstName +
                                                                " " +
                                                                appointment
                                                                    ?.patient
                                                                    ?.lastName}
                                                        </p>
                                                        <p
                                                            style={{
                                                                color: "grey",
                                                                fontSize:
                                                                    "14px",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#0288d1",
                                                                }}
                                                            >
                                                                Mobile No :
                                                            </span>{" "}
                                                            {appointment
                                                                ?.patient
                                                                ?.phoneNo || ""}
                                                        </p>
                                                        <p
                                                            style={{
                                                                color: "grey",
                                                                fontSize:
                                                                    "14px",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#0288d1",
                                                                }}
                                                            >
                                                                Address :
                                                            </span>{" "}
                                                            {(
                                                                appointment
                                                                    ?.patient
                                                                    ?.address ||
                                                                ""
                                                            ).toUpperCase()}
                                                        </p>
                                                    </div>
                                                    <div
                                                        style={{
                                                            borderRadius: "8px",
                                                            width: "45%",
                                                        }}
                                                    >
                                                        <p
                                                            style={{
                                                                color: "grey",
                                                                fontSize:
                                                                    "14px",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#0288d1",
                                                                }}
                                                            >
                                                                Age/Gender
                                                                :{" "}
                                                            </span>
                                                            {(appointment
                                                                .patient
                                                                .birthDate &&
                                                            appointment.patient
                                                                .birthDate !==
                                                                "Invalid date" &&
                                                            getAge(
                                                                appointment
                                                                    .patient
                                                                    .birthDate,
                                                            ) > 0
                                                                ? `${getAge(appointment.patient.birthDate)} years`
                                                                : appointment
                                                                        .patient
                                                                        .age
                                                                  ? `${appointment.patient.age} years`
                                                                  : "0 years") +
                                                                " / " +
                                                                appointment
                                                                    .patient
                                                                    .gender}
                                                        </p>
                                                        <p
                                                            style={{
                                                                color: "grey",
                                                                fontSize:
                                                                    "14px",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#0288d1",
                                                                }}
                                                            >
                                                                Patient ID:
                                                            </span>{" "}
                                                            {
                                                                appointment
                                                                    ?.patient
                                                                    ?.patientNumber
                                                            }
                                                        </p>
                                                        <p
                                                            style={{
                                                                color: "grey",
                                                                fontSize:
                                                                    "14px",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    color: "#0288d1",
                                                                }}
                                                            >
                                                                Date and Time:
                                                            </span>{" "}
                                                            {dayjs(
                                                                appointment?.date?.toLocaleString(),
                                                            ).format(
                                                                "DD-MM-YYYY",
                                                            ) +
                                                                "/" +
                                                                to12HourFormat(
                                                                    appointment.time,
                                                                )}
                                                        </p>
                                                    </div>
                                                </div>

                                                <p
                                                    style={{
                                                        color: "grey",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#0288d1",
                                                        }}
                                                    >
                                                        By:
                                                    </span>{" "}
                                                    Dr.
                                                    {appointment?.doctor?.name}
                                                </p>
                                                <hr />
                                                {selectedOptions.includes(
                                                    "Vital Signs",
                                                ) && (
                                                    <div>
                                                        <h3
                                                            style={{
                                                                color: "#424242",
                                                                fontSize:
                                                                    "22px",
                                                                fontWeight:
                                                                    "bold",
                                                                marginBottom:
                                                                    "10px",
                                                            }}
                                                        >
                                                            Vital Signs
                                                        </h3>
                                                        <table
                                                            style={{
                                                                width: "100%",

                                                                color: "#616161",
                                                                marginBottom:
                                                                    "20px",
                                                                maxWidth:
                                                                    "800px",
                                                            }}
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding:
                                                                                "5px",
                                                                        }}
                                                                    >
                                                                        Weight
                                                                        (kg)
                                                                    </th>
                                                                    <th
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding:
                                                                                "5px",
                                                                        }}
                                                                    >
                                                                        B.P.
                                                                        (mmHg)
                                                                    </th>
                                                                    <th
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding:
                                                                                "5px",
                                                                        }}
                                                                    >
                                                                        Pulse
                                                                        (Heartbeats/min)
                                                                    </th>
                                                                    <th
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding:
                                                                                "5px",
                                                                        }}
                                                                    >
                                                                        Temperature
                                                                        (°C)
                                                                    </th>
                                                                    <th
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding:
                                                                                "5px",
                                                                        }}
                                                                    >
                                                                        Resp.
                                                                        Rate
                                                                        (breaths/min)
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {appointment?.vitalSigns && (
                                                                    <tr
                                                                        style={{
                                                                            backgroundColor:
                                                                                "#fafafa",
                                                                        }}
                                                                    >
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                            }}
                                                                        >
                                                                            {
                                                                                appointment
                                                                                    .vitalSigns
                                                                                    .weight
                                                                            }
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                            }}
                                                                        >
                                                                            {
                                                                                appointment
                                                                                    .vitalSigns
                                                                                    .bp
                                                                            }
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                            }}
                                                                        >
                                                                            {
                                                                                appointment
                                                                                    .vitalSigns
                                                                                    .pulse
                                                                            }
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                            }}
                                                                        >
                                                                            {
                                                                                appointment
                                                                                    .vitalSigns
                                                                                    .temperature
                                                                            }
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                            }}
                                                                        >
                                                                            {
                                                                                appointment
                                                                                    .vitalSigns
                                                                                    .respRate
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                                <div
                                                    style={{
                                                        marginBottom: "20px",
                                                    }}
                                                >
                                                    <h4
                                                        style={{
                                                            color: "#424242",
                                                            fontSize: "20px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        Clinical Notes:
                                                    </h4>

                                                    {appointment?.clinicalNote
                                                        ?.complaints &&
                                                        `Complaints - ${appointment.clinicalNote.complaints}, `}

                                                    {appointment?.clinicalNote
                                                        ?.presentIllness &&
                                                        `Present Illness - ${appointment.clinicalNote.presentIllness}, `}
                                                    {appointment?.clinicalNote
                                                        ?.investigations &&
                                                        `Duration - ${appointment.clinicalNote.investigations}, `}
                                                    {appointment?.clinicalNote
                                                        ?.psychiatricHistory &&
                                                        `Past Psychiatric History - ${appointment.clinicalNote.psychiatricHistory}, `}
                                                    {appointment?.clinicalNote
                                                        ?.medicalHistory &&
                                                        `Medical History - ${appointment.clinicalNote.medicalHistory}, `}
                                                    {appointment?.clinicalNote
                                                        ?.treatmentHistory &&
                                                        `Treatment History - ${appointment.clinicalNote.treatmentHistory}, `}

                                                    {appointment?.clinicalNote
                                                        ?.familyHistory &&
                                                        `Family History - ${appointment.clinicalNote.familyHistory}, `}

                                                    {appointment?.clinicalNote
                                                        ?.diagnosis &&
                                                        `Prov. Diagnosis - ${appointment.clinicalNote.diagnosis}`}
                                                    {appointment?.clinicalNote
                                                        ?.Observations &&
                                                        `Observations - ${appointment.clinicalNote.Observations}, `}
                                                    {appointment?.clinicalNote
                                                        ?.notes &&
                                                        `Notes - ${appointment.clinicalNote.notes}, `}
                                                </div>

                                                <h4
                                                    style={{
                                                        color: "#424242",
                                                        fontSize: "20px",
                                                        fontWeight: "bold",
                                                        marginBottom: "20px",
                                                    }}
                                                >
                                                    Prescriptions:
                                                </h4>
                                                <table
                                                    style={{
                                                        width: "100%",
                                                        color: "#616161",
                                                        marginBottom: "20px",
                                                    }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding:
                                                                        "5px",
                                                                }}
                                                            >
                                                                S.No
                                                            </th>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding:
                                                                        "5px",
                                                                }}
                                                            >
                                                                Drug
                                                            </th>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding:
                                                                        "5px",
                                                                }}
                                                            >
                                                                Dosage
                                                            </th>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding:
                                                                        "5px",
                                                                }}
                                                            >
                                                                Duration
                                                            </th>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding:
                                                                        "5px",
                                                                }}
                                                            >
                                                                Instructions
                                                            </th>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding:
                                                                        "5px",
                                                                }}
                                                            >
                                                                Quantity
                                                            </th>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding:
                                                                        "5px",
                                                                }}
                                                            >
                                                                Show Generic
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {appointment &&
                                                            appointment.prescription &&
                                                            appointment.prescription.map(
                                                                (
                                                                    pres,
                                                                    index,
                                                                ) => (
                                                                    <tr
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                                padding:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            {index +
                                                                                1}
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                                padding:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            <div>
                                                                                {pres.drugType !==
                                                                                "custom"
                                                                                    ? pres.drugType?.toUpperCase()
                                                                                    : ""}{" "}
                                                                                {
                                                                                    pres.drug
                                                                                }
                                                                            </div>
                                                                            {pres.genericName &&
                                                                                showGenericNames[
                                                                                    index
                                                                                ] && (
                                                                                    <div
                                                                                        style={{
                                                                                            fontSize:
                                                                                                "11px",
                                                                                            color: "#757575",
                                                                                            marginTop:
                                                                                                "2px",
                                                                                        }}
                                                                                    >
                                                                                        (
                                                                                        {
                                                                                            pres.genericName
                                                                                        }

                                                                                        )
                                                                                    </div>
                                                                                )}
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                                padding:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            {
                                                                                pres.dosage
                                                                            }
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                                padding:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            {pres.durationNumber +
                                                                                " " +
                                                                                pres.durationUnit}
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                                padding:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            {
                                                                                pres.instruction
                                                                            }
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                                padding:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            {pres?.quantity ||
                                                                                getQuantity(
                                                                                    pres.dosage,
                                                                                    pres.durationNumber +
                                                                                        " " +
                                                                                        pres.durationUnit,
                                                                                )}
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                border: "1px solid #ddd",
                                                                                padding:
                                                                                    "5px",
                                                                                textAlign:
                                                                                    "center",
                                                                            }}
                                                                        >
                                                                            {pres.genericName && (
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={
                                                                                        showGenericNames[
                                                                                            index
                                                                                        ] ||
                                                                                        false
                                                                                    }
                                                                                    onChange={() =>
                                                                                        handleGenericNameToggle(
                                                                                            index,
                                                                                        )
                                                                                    }
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        width: "18px",
                                                                                        height: "18px",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ),
                                                            )}
                                                    </tbody>
                                                </table>

                                                {selectedOptions.includes(
                                                    "MedicalHistory",
                                                ) && (
                                                    <>
                                                        <h4>Medical History</h4>
                                                        {appointment?.patient
                                                            ?.medicalhistory
                                                            ?.length > 0 && (
                                                            <div>
                                                                {appointment.patient.medicalhistory.join(
                                                                    ", ",
                                                                )}
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                <div
                                                    style={{
                                                        marginTop: "16px",
                                                        padding: "16px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "4px",
                                                        width: "100%",
                                                        maxWidth: "800px",
                                                    }}
                                                ></div>
                                                <h4
                                                    style={{
                                                        color: "#424242",
                                                        fontSize: "20px",
                                                        fontWeight: "bold",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    Additional Notes:
                                                </h4>
                                                <p
                                                    style={{
                                                        color: "#616161",
                                                        fontSize: "14px",
                                                        lineHeight: "1.6",
                                                    }}
                                                >
                                                    {appointment &&
                                                        (appointment.notes !=
                                                        "undefined"
                                                            ? appointment.notes
                                                            : "")}
                                                </p>
                                            </div>
                                        )}
                                        {selectedOptions.includes(
                                            "billing",
                                        ) && (
                                            <div
                                                style={{
                                                    padding: "24px",
                                                    pageBreakBefore: "always",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        borderBottom:
                                                            "1px solid #ccc",
                                                        paddingBottom: "16px",
                                                    }}
                                                >
                                                    <h5>
                                                        Appointment with{" "}
                                                        {
                                                            appointment?.doctor
                                                                .name
                                                        }
                                                    </h5>
                                                    <p>
                                                        {dayjs(
                                                            appointment?.date,
                                                        ).format(
                                                            "DD MMMM, hh:mm A",
                                                        )}
                                                    </p>
                                                </div>

                                                <div
                                                    style={{
                                                        marginTop: "24px",
                                                    }}
                                                >
                                                    <h4>Invoice</h4>
                                                    <table
                                                        style={{
                                                            width: "100%",
                                                            borderCollapse:
                                                                "collapse",
                                                            border: "1px solid #ddd",
                                                        }}
                                                    >
                                                        <thead>
                                                            <tr
                                                                style={{
                                                                    backgroundColor:
                                                                        "#f9f9f9",
                                                                }}
                                                            >
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding:
                                                                            "8px",
                                                                    }}
                                                                >
                                                                    Treatment
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding:
                                                                            "8px",
                                                                    }}
                                                                >
                                                                    Unit
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding:
                                                                            "8px",
                                                                    }}
                                                                >
                                                                    Cost (₹)
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding:
                                                                            "8px",
                                                                    }}
                                                                >
                                                                    Discount (%)
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding:
                                                                            "8px",
                                                                    }}
                                                                >
                                                                    Tax (%)
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding:
                                                                            "8px",
                                                                    }}
                                                                >
                                                                    Total (₹)
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {appointment &&
                                                                appointment?.billing &&
                                                                appointment?.billing?.treatment.map(
                                                                    (item) => (
                                                                        <tr
                                                                            key={
                                                                                item.id
                                                                            }
                                                                        >
                                                                            <td
                                                                                style={{
                                                                                    border: "1px solid #ddd",
                                                                                    padding:
                                                                                        "8px",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    item.name
                                                                                }
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    border: "1px solid #ddd",
                                                                                    padding:
                                                                                        "8px",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    item.unit
                                                                                }
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    border: "1px solid #ddd",
                                                                                    padding:
                                                                                        "8px",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    item.cost
                                                                                }
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    border: "1px solid #ddd",
                                                                                    padding:
                                                                                        "8px",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    item.discount
                                                                                }
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    border: "1px solid #ddd",
                                                                                    padding:
                                                                                        "8px",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    item.tax
                                                                                }
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    border: "1px solid #ddd",
                                                                                    padding:
                                                                                        "8px",
                                                                                }}
                                                                            >
                                                                                {item.unit *
                                                                                    item.cost}
                                                                            </td>
                                                                        </tr>
                                                                    ),
                                                                )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div
                                                    style={{
                                                        marginTop: "24px",
                                                        borderTop:
                                                            "1px solid #ccc",
                                                        paddingTop: "16px",
                                                    }}
                                                >
                                                    <h4>Summary</h4>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "space-between",
                                                        }}
                                                    >
                                                        <div>
                                                            <p>
                                                                Total Cost: ₹
                                                                {appointment &&
                                                                    appointment
                                                                        ?.billing
                                                                        ?.totalCost}
                                                            </p>
                                                            <p>
                                                                Total Discount:
                                                                ₹
                                                                {appointment &&
                                                                    appointment
                                                                        ?.billing
                                                                        ?.totalDiscount}
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <p>
                                                                Total Tax: ₹
                                                                {appointment &&
                                                                    appointment
                                                                        ?.billing
                                                                        ?.totalTax}
                                                            </p>
                                                            <p>
                                                                Grand Total: ₹
                                                                {appointment &&
                                                                    appointment
                                                                        ?.billing
                                                                        ?.grandTotal}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    style={{
                                                        marginTop: "24px",
                                                        borderTop:
                                                            "1px solid #ccc",
                                                        paddingTop: "16px",
                                                    }}
                                                >
                                                    <h4>Payment</h4>
                                                    <p>
                                                        Payment Method:{" "}
                                                        {appointment &&
                                                            appointment?.billing
                                                                ?.paymentMethod}
                                                    </p>
                                                    <p>
                                                        Status:{" "}
                                                        {appointment &&
                                                            appointment?.billing
                                                                ?.paid}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            padding: "20px",
                                            fontFamily: "Arial, sans-serif",
                                        }}
                                    >
                                        <h3 style={{ color: "#0288d1" }}>
                                            Select Sections:
                                        </h3>
                                        {options.map((option) => (
                                            <div
                                                key={option.id}
                                                style={{ marginBottom: "10px" }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    id={`checkbox-${option.id}`}
                                                    value={option.label}
                                                    checked={selectedOptions.includes(
                                                        option.label,
                                                    )}
                                                    onChange={() =>
                                                        handleCheckboxChange(
                                                            option.label,
                                                        )
                                                    }
                                                />
                                                <label
                                                    htmlFor={`checkbox-${option.id}`}
                                                    style={{
                                                        marginLeft: "8px",
                                                        color: "#424242",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                        <div style={{ marginTop: "20px" }}>
                                            <h4 style={{ color: "#424242" }}>
                                                Selected Options:
                                            </h4>
                                            {selectedOptions.length > 0 ? (
                                                <ul
                                                    style={{
                                                        color: "#616161",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {selectedOptions.map(
                                                        (option, index) => (
                                                            <li key={index}>
                                                                {option}
                                                            </li>
                                                        ),
                                                    )}
                                                </ul>
                                            ) : (
                                                <p
                                                    style={{
                                                        color: "#616161",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    No options selected.
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </main>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={handleClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PrintPres;
